import apiClient from '@/core/api/client';
import { API_ENDPOINTS } from '@/core/api/endpoints';
import { KnowledgeBaseListResponse, KnowledgeBaseResponse, KnowledgeBaseUploadRequest } from '../types';

/**
 * Knowledge Hub API Service
 */
export const knowledgeHubApi = {
    /**
     * Get all knowledge base files
     */
    getFiles: async (schoolSlug: string): Promise<KnowledgeBaseListResponse> => {
        try {
            const response = await apiClient.get<KnowledgeBaseListResponse>(API_ENDPOINTS.KNOWLEDGE_HUB.LIST(schoolSlug));
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to fetch knowledge base files'
            };
        }
    },

    /**
     * Upload a new file
     */
    uploadFile: async (schoolSlug: string, data: KnowledgeBaseUploadRequest): Promise<KnowledgeBaseResponse> => {
        try {
            const formData = new FormData();
            formData.append('title', data.title);
            formData.append('file', data.file);
            formData.append('department_id', data.department_id);

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };

            const response = await apiClient.post<KnowledgeBaseResponse>(API_ENDPOINTS.KNOWLEDGE_HUB.UPLOAD(schoolSlug), formData, config);
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to upload file'
            };
        }
    },

    /**
     * Delete a file
     */
    deleteFile: async (schoolSlug: string, kbId: string): Promise<KnowledgeBaseResponse> => {
        try {
            const response = await apiClient.delete<KnowledgeBaseResponse>(API_ENDPOINTS.KNOWLEDGE_HUB.DELETE(schoolSlug, kbId));
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to delete file'
            };
        }
    }
};
